import { Injectable } from '@angular/core';
import { Toast } from '../../core/components/toast/toast';

@Injectable({
  providedIn: 'root',
})
export class ToastService {
  private toastComponent!: Toast;

  constructor() { }
  
  setToastComponent(toastComponent: Toast): void {
    this.toastComponent = toastComponent;
  }

  show(message: string, type: string = 'success', duration: number = 3000): void {
    this.toastComponent.showToast(message, type, duration);
  }
}  
